/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItem_viewer$ref = any;
export type CartItems_viewer$ref = any;
export type CartItems_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": CartItem_viewer$ref;
    readonly " $refType": CartItems_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItems_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItem_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ba3439a49ea841429d72ab0ec130696a';
export default node;
